export const CREATE_CLIENT_ADMIN = 'CREATE_CLIENT_ADMIN';
export const CREATE_CLIENT_ADMIN_SUCCESS = 'CREATE_CLIENT_ADMIN_SUCCESS';
export const CREATE_CLIENT_ADMIN_ERROR = 'CREATE_CLIENT_ADMIN_ERROR';

export const createTechnician = (data, onSuccess) => ({
  type: CREATE_CLIENT_ADMIN,
  payload: data,
  onSuccess,
});
